<template>
    <div v-if="application" class="board-container">
        <view-program v-if="application.program" :program="application.program" />
        <view-application v-if="application" :application="application" />
        <div class="board-buttons">
            <div class="left">
                <a class="button button--border" @click="list"><span>리스트</span></a>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";

import ViewProgram from "./view-program.vue";
import ViewApplication from "./view-application.vue";

export default {
    components: {
        ViewProgram,
        ViewApplication,
    },
    props: ["_application"],
    data() {
        return {
            application: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var { application } = await api.v1.services.applications.get({ _id: this._application });
                this.application = application;
            } catch (error) {
                this.$handleError(error);
            }
        },

        list() {
            this.$router.go(-1);
        },
    },
};
</script>
